import { Avatar, KpiCard, StatusBadge } from "@maeiz/ui";
import { DocPage, Section, Demo, SpecTable } from "../../components/DocChrome";

export function DomainPage() {
    return (
        <DocPage
            title="MAEIZ Domain Components"
            description="Composites grounded in water-delivery operations — shared across panels when the pattern repeats."
        >
            <Section title="Identity">
                <Demo className="flex flex-wrap items-center gap-4">
                    <Avatar name="Rider Ali" />
                    <Avatar name="Customer Sara" size="lg" />
                    <StatusBadge status="open" />
                    <StatusBadge status="verified" />
                    <StatusBadge status="offline" />
                </Demo>
            </Section>
            <Section title="Operations KPIs">
                <Demo className="grid gap-4 sm:grid-cols-3">
                    <KpiCard label="Bottles on hand" value="128" accent="primary" />
                    <KpiCard label="Cash collected" value="₨ 8,200" accent="gold" />
                    <KpiCard
                        label="Failed payments"
                        value="2"
                        accent="danger"
                        hint="Needs follow-up"
                    />
                </Demo>
            </Section>
            <Section title="Domain status vocabulary">
                <SpecTable
                    rows={[
                        ["Shift", "open → closed"],
                        ["Delivery sync", "pending → synced | error"],
                        ["Payment", "pending → succeeded | failed"],
                        ["Subscription", "active | past_due | cancelled"],
                    ]}
                />
            </Section>
        </DocPage>
    );
}
